module.exports = __webpack_public_path__ + "static/media/entertaiment-icon.5a33cea4.svg";